import { usePortal } from '@fourthwall/utils/dist/hooks/usePortal'
import { useEffect, useState } from 'react'

type Options = {
  disableBodyScroll?: boolean
}

export const useDrawer = (id: string, options?: Options) => {
  const drawerRoot = usePortal(id)
  const [drawerActive, setDrawerActive] = useState(false)

  const drawerOpen = () => {
    setDrawerActive(true)
  }

  const drawerClose = () => {
    setDrawerActive(false)
  }

  useEffect(() => {
    if (options?.disableBodyScroll) {
      document.body.style.overflow = drawerActive ? 'hidden' : ''
    }
  }, [drawerActive, options?.disableBodyScroll])

  return {
    drawerRoot,
    drawerActive,
    drawerOpen,
    drawerClose,
  }
}
